import { useState } from 'react';
import SVGInline from 'react-svg-inline';
import { Link } from '@hc/redux-saga-router-plus';

import CommentsContainer from 'legacy/containers/property-explorer-comments';
import DownloadReportButton from 'legacy/containers/download-report-button';
import ShareReportButton from 'legacy/containers/share-report-button';
import ListingRemarks from 'legacy/components/ListingRemarks';
import { ClientId } from 'legacy/containers/client-id';

import { Dialog } from 'legacy/components/Dialog';
import LimitedReportWarning from 'legacy/components/LimitedReportWarning';
import CommentIcon from 'legacy/components/CommentIcon';
import IconButton from 'legacy/components/generic/IconButton';

import {
  wholeNumberFormatterPlaceholder,
  placeholderFormatter,
  pluralize,
  dollarsFormatter
} from 'legacy/utils/formatters';

import sale from 'legacy/assets/svg-inline/sale.svg';

import { PropertyExplorerStaticPropertyDetails as theme } from 'legacy/css-modules';

export default ({
  property,
  limitedReport,
  showAllDetails,
  shareModal,
  onClose,
  isReadOnly,
  clientId,
  commentValue
}) => {
  const [commentActive, setCommentActive] = useState(false);
  const {
    unit,
    unitDesignator,
    city,
    state,
    zipcode,
    streetAddress,
    grossLivingAreaSqft,
    yearBuilt,
    // Since we're not sure of the data consistency here, equate null to 0 for now
    // for dependable downstream logic
    bathrooms = 0,
    bedrooms = 0,
    propertyType,
    propertyStatus,
    lastListPrice
  } = property;

  return (
    <div className={theme.Component} data-hc-name="subject-address-section">
      {limitedReport && (
        <div className={theme.ProductLogoRow}>
          <LimitedReportWarning
            className={theme.LimitedReportWarning}
            tooltip
          />
        </div>
      )}
      <div className={theme.TopContainer}>
        {propertyStatus && propertyStatus === 'Active' && (
          <div className={theme.ForSaleTextContainer}>
            <SVGInline
              height="20px"
              width="20px"
              className={theme.ForSaleIcon}
              svg={sale}
            />
            <div className={theme.ForSaleText}>For Sale</div>
            <div className={theme.ForSalePrice}>
              {lastListPrice ? dollarsFormatter(lastListPrice) : '--'}
            </div>
          </div>
        )}
        <ClientId className={theme.ClientId} />
      </div>
      <div className={theme.IconContainer}>
        <div>
          <Dialog
            active={commentActive}
            title={'Comment on this report'}
            onClose={() => {
              setCommentActive(false);
            }}
            className={theme.Dialog}
            closeButton
          >
            <CommentsContainer
              onClose={() => {
                setCommentActive(false);
              }}
            />
          </Dialog>
          <div className={theme.SingleIconContainer}>
            <IconButton
              onClick={() => {
                setCommentActive(true);
              }}
              dataHcName="comment-button"
              label={'Comment'}
              disabled={isReadOnly && !commentValue}
              icon={
                <div className={theme.CommentIcon}>
                  <CommentIcon hasComment={!!commentValue} />
                </div>
              }
            />
          </div>
        </div>

        <div className={theme.SingleIconContainer}>
          <DownloadReportButton />
        </div>

        <div>
          <ShareReportButton />
        </div>
      </div>
      <div>
        <div
          className={theme.StreetAddress}
          data-hc-name="subject-address-street-text"
        >
          {streetAddress}{' '}
          {unit && unitDesignator ? `${unitDesignator} ${unit}` : unit}
        </div>
        <div
          className={theme.CityStateZip}
          title={property.companyName}
          data-hc-name="subject-address-city-text"
        >
          {city}, {state} {zipcode}
        </div>
      </div>
      {(showAllDetails || (propertyType && grossLivingAreaSqft)) && (
        <div className={theme.OtherDetails}>
          <span
            className={theme.OtherDetailsItems}
            data-hc-name="subject-property-type-text"
          >
            {propertyType}
          </span>
          <span
            className={theme.OtherDetailsItems}
            data-hc-name="subject-property-beds"
          >
            {placeholderFormatter(bedrooms)} {pluralize('Bed', bedrooms)}
          </span>
          <span
            className={theme.OtherDetailsItems}
            data-hc-name="subject-property-baths"
          >
            {placeholderFormatter(bathrooms)} {pluralize('Bath', bathrooms)}
          </span>
          <span
            className={theme.OtherDetailsItems}
            data-hc-name="subject-property-sqft"
          >
            {wholeNumberFormatterPlaceholder(grossLivingAreaSqft)} Sq.Ft.
          </span>
          <span
            className={theme.OtherDetailsItems}
            data-hc-name="subject-property-year-built"
          >
            Built {yearBuilt}
          </span>
        </div>
      )}
      <div>{showAllDetails && <ListingRemarks addressId="subject" />}</div>
    </div>
  );
};
